var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.63 136.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#8a92b2;}.e{fill:#62688f;}.f{fill:#454a75;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "41.8 0 0 69.36 41.8 50.36 41.8 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "41.8 50.36 0 69.36 41.8 94.08 41.8 50.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "83.61 69.36 41.8 0 41.8 50.36 83.61 69.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "41.8 94.08 83.61 69.36 41.8 50.36 41.8 94.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "0 77.29 41.8 136.2 41.8 101.99 0 77.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "41.8 101.99 41.8 136.2 83.63 77.29 41.8 101.99"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.ef5f499af295f0be7d4d7f74219e42e7.svg";
export { ForwardRef as ReactComponent };